// Uses uuid/v4 for all IDs (existing pattern from createTask.js)
export default {
  // Full page records from API, indexed by record.id (MongoDB _id)
  // Shape: { id, name, pid, page: {...}, created_at, updated_at }
  recordsById: {},

  // All pages indexed by pageId (record.page.id)
  // Shape: { id, recordId, meta, created_at, updated_at }
  // recordId links back to the API record for saving
  pagesById: {},

  // Active page being rendered (uses pageId, not recordId)
  activePageId: null,

  // Normalized nodes across all pages
  // Key: nodeId (UUID), Value: { id, pageId, parentId, nodeType, props, afterId, draggable, droppable }
  nodesById: {},

  // Parent-to-children mapping for efficient tree traversal
  // Key: parentId (UUID or 'root_${pageId}'), Value: [childId, childId, ...]
  childrenByParent: {},

  // Registered custom components
  // Key: nodeType string, Value: Vue component
  registeredComponents: {},

  // Pending updates for batching (flushed per animation frame)
  updateQueue: [],

  // Loading/dirty states
  loading: false,
  saving: false,
};
